import { useState, useEffect } from "react";
import { Grid, Column } from "@able/react";
import FilterDropDownMenu from "../common/filter-dropdown-menu-component";
import dayjs from "../../../../utils/dayjs-util";

import { useFetchSubscriptionUplinkThroughputHistoryQuery } from "../../../../queries/subscription-throughput-queries";
import { formatSubscriptionUplinkThroughPutData } from "../../../../utils/throughput-data-util";
import ThroughputChartNoResults from "../common/throughput-chart-noresults-component";
import ThroughputValues from "./throughput-values-component";
import UpLinkHighChartsWrapper from "./uplink-highchart-wrapper-component";
import "../common/filter-dropdown-menu-component-style.scss";

function UplinkThroughputChart({ subscriptionId }) {
    const [displayLastDays, setDisplayLastDays] = useState(true);
    const [displayCurrentDay, setDisplayCurrentDay] = useState(false);
    const [period, setPeriod] = useState("daily");
    const [data, setData] = useState({});
    const [subscriptionUplinkThroughputData, setSubscriptionUplinkThroughputData] = useState([]);
    const currentDate = dayjs().tz("Australia/Melbourne");
    let dateTimeFrom;
    let dateTimeTo;
    const periodVar = displayLastDays ? "daily" : "hourly";

    if (displayLastDays) {
        dateTimeFrom = currentDate.subtract(30, "day").startOf("day").utc().format("YYYY-MM-DDTHH:mm:ss");
        dateTimeTo = currentDate.startOf("day").utc().format("YYYY-MM-DDTHH:mm:ss");
    } else if (displayCurrentDay) {
        dateTimeFrom = currentDate.startOf("day").utc().format("YYYY-MM-DDTHH:mm:ss");
        dateTimeTo = currentDate.endOf("day").utc().format("YYYY-MM-DDTHH:mm:ss");
    }

    const { subscriptionData, isLoading, isSuccess } = useFetchSubscriptionUplinkThroughputHistoryQuery(
        subscriptionId,
        periodVar,
        dateTimeFrom,
        dateTimeTo
    );

    useEffect(() => {
        if (!isLoading && isSuccess) {
            setSubscriptionUplinkThroughputData(subscriptionData);
            const formattedData = formatSubscriptionUplinkThroughPutData(subscriptionData, periodVar);
            setData({
                filteredData: formattedData,
                networkThroughPut: [],
                barKey: "downLink",
                period: periodVar,
            });
        }
    }, [subscriptionData, isLoading, isSuccess, periodVar]);

    return (
        <>
            <Grid className="throughput-content-detail">
                <Column vxs={12} bsm={12} bmd={12} blg={12}>
                    <FilterDropDownMenu
                        setDisplayLastDays={setDisplayLastDays}
                        setDisplayCurrentDay={setDisplayCurrentDay}
                        setPeriod={setPeriod}
                    />
                </Column>
                {!isLoading && isSuccess && (
                    <>
                        <Column vxs={12} bsm={3} bmd={3} blg={3}>
                            <div className="left-content">
                                <ThroughputValues
                                    subscriptionThroughput={subscriptionUplinkThroughputData?.series}
                                    period={period}
                                ></ThroughputValues>
                            </div>
                        </Column>
                        <Column vxs={12} bsm={9} bmd={9} blg={9}>
                            <UpLinkHighChartsWrapper
                                subscriptionId={subscriptionId}
                                subscriptionData={subscriptionData}
                                formattedSubscriptionThroughputData={data.filteredData}
                                period={period}
                                setPeriod={setPeriod}
                                dateTimeFrom={dateTimeFrom}
                                dateTimeTo={dateTimeTo}
                                setSubscriptionUplinkThroughputData={setSubscriptionUplinkThroughputData}
                                selectedOption={displayLastDays ? "displaylastdays" : "today"}
                            />
                        </Column>
                    </>
                )}
                {!isLoading && !isSuccess && <ThroughputChartNoResults />}
                {isLoading && !isSuccess && (
                    <Column vxs={12} bsm={12} bmd={12} blg={12}>
                        <div className="loading loader-align-center">
                            Loading {displayCurrentDay ? "current day" : "last 30 days"} performance data
                        </div>
                    </Column>
                )}
            </Grid>
        </>
    );
}

export default UplinkThroughputChart;
